export default __webpack_public_path__ + "static/media/chart_very_low.a515a2f6.png";